import React from 'react';

// helpers
import {useScreenWidth} from '../../../hooks';
import {useTheme} from '@emotion/react';

// components
import CardDetailsSkeletonMobile from './CardDetailsSkeletonMobile';
import CardDetailsSkeletonDesktop from './CardDetailsSkeletonDesktop';

// types
type Props = {
  variant: 'summary' | 'detailed';
};

const CardDetailsSkeleton = ({variant}: Props) => {
  const screenWidth = useScreenWidth();
  const {skeleton, screenBreakpoint} = useTheme();

  const columns = [
    {
      headerWidth: skeleton.text.width.md,
      contentWidth: skeleton.text.width.lg,
    },
    {
      headerWidth: skeleton.text.width.lg,
      contentWidth: skeleton.text.width.md,
    },
    {
      headerWidth: skeleton.text.width.xl,
      contentWidth: skeleton.text.width.md,
    },
    {
      headerWidth: skeleton.text.width.lg,
      contentWidth: skeleton.text.width.xl,
    },
    {
      headerWidth: skeleton.text.width.md,
      contentWidth: skeleton.text.width.xl,
    },
    {
      headerWidth: skeleton.text.width.lg,
      contentWidth: skeleton.text.width.lg,
    },
    {
      headerWidth: skeleton.text.width.lg,
      contentWidth: skeleton.text.width.lg,
    },
    {
      headerWidth: skeleton.text.width.xl,
      contentWidth: skeleton.text.width.xsm,
    },
    {
      headerWidth: skeleton.text.width.lg,
      contentWidth: skeleton.text.width.lg,
    },
    {
      headerWidth: skeleton.text.width.md,
      contentWidth: skeleton.text.width.lg,
    },
    {
      headerWidth: skeleton.text.width.md,
      contentWidth: skeleton.text.width.xl,
    },
  ];

  return (
    <>
      {screenWidth < screenBreakpoint.md.value ? (
        <CardDetailsSkeletonMobile columns={columns} variant={variant} />
      ) : (
        <CardDetailsSkeletonDesktop columns={columns} variant={variant} />
      )}
    </>
  );
};

export default CardDetailsSkeleton;
